var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5H10C10.55 8.5 11 8.05 11 7.5V2C11 1.45 10.55 1 10 1H6C5.45 1 5 1.45 5 2V7.5C5 8.05 5.45 8.5 6 8.5ZM6 2H10V7.5H6V2ZM4 9.5H7V10.5H4C3.45 10.5 3 10.05 3 9.5V4H4V9.5ZM2 11.5H5V12.5H2C1.45 12.5 1 12.05 1 11.5V6H2V11.5ZM15 12L12 15L11.3 14.3L13.1 12.5H8.5V11.5H13.1L11.3 9.7L12 9L15 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTaskIcon);
export default __webpack_public_path__ + "static/media/job-task-icon.addf9003dbe3d72b7fc4e3f381161c96.svg";
export { ForwardRef as ReactComponent };